'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _autocompleteCommands = require('@/res/autocompleteCommands');

var _autocompleteCommands2 = _interopRequireDefault(_autocompleteCommands);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _AutoComplete = require('./AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _TextStyle = require('./inputtools/TextStyle');

var _TextStyle2 = _interopRequireDefault(_TextStyle);

var _Emoji = require('./inputtools/Emoji');

var _Emoji2 = _interopRequireDefault(_Emoji);

var _SelfUser = require('./SelfUser');

var _SelfUser2 = _interopRequireDefault(_SelfUser);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingUsersList = require('./TypingUsersList');

var _TypingUsersList2 = _interopRequireDefault(_TypingUsersList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AutoComplete: _AutoComplete2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        SelfUser: _SelfUser2.default,
        TypingUsersList: _TypingUsersList2.default
    },
    props: ['container', 'buffer'],
    data: function data() {
        return {
            self: this,
            selfuser_open: false,
            autocomplete_open: false,
            autocomplete_items: [],
            autocomplete_filter: '',

            autocomplete_filtering: true,
            active_tool: null,
            active_tool_props: {},
            pluginUiElements: _GlobalApi2.default.singleton().controlInputPlugins,
            showPlugins: true,
            current_input_value: '',
            has_focus: false
        };
    },

    computed: {
        currentNick: function currentNick() {
            var activeNetwork = _state2.default.getActiveNetwork();
            return activeNetwork ? activeNetwork.nick : '';
        },
        networkState: function networkState() {
            var activeNetwork = _state2.default.getActiveNetwork();
            return activeNetwork ? activeNetwork.state : '';
        },
        shouldShowSendButton: function shouldShowSendButton() {
            return this.$state.ui.is_touch || this.$state.setting('showSendButton');
        },
        shouldShowEmojiPicker: function shouldShowEmojiPicker() {
            return this.$state.setting('showEmojiPicker') && !this.$state.ui.is_touch;
        },
        shouldShowColorPicker: function shouldShowColorPicker() {
            return this.$state.setting('showColorPicker');
        },
        shouldShowInputButtons: function shouldShowInputButtons() {
            if (this.pluginUiElements.length || this.shouldShowEmojiPicker || this.shouldShowColorPicker) {
                return true;
            }
            return false;
        },
        history: function history() {
            if (_state2.default.setting('buffers.shared_input')) {
                return this.$state.ui.input_history;
            }
            return this.buffer.input_history;
        },

        history_pos: {
            get: function get() {
                if (_state2.default.setting('buffers.shared_input')) {
                    return this.$state.ui.input_history_pos;
                }
                return this.buffer.input_history_pos;
            },
            set: function set(newVal) {
                if (_state2.default.setting('buffers.shared_input')) {
                    this.$state.ui.input_history_pos = newVal;
                } else {
                    this.buffer.input_history_pos = newVal;
                }
            }
        }
    },
    watch: {
        history_pos: function history_pos(newVal) {
            var val = this.history[this.history_pos];
            this.$refs.input.setValue(val || '');
        },
        buffer: function buffer() {
            if (!_state2.default.setting('buffers.shared_input')) {
                this.inputRestore();
            }

            this.autocomplete_open = false;
        }
    },
    created: function created() {
        var _this = this;

        this.typingTimer = null;
        this.lastTypingTime = 0;

        this.listen(_state2.default, 'document.keydown', function (ev) {
            if (!_this.$refs.input) {
                return;
            }

            if (ev.ctrlKey || ev.altKey || ev.metaKey) {
                return;
            }

            if (ev.keyCode === 16) {
                return;
            }

            if (ev.keyCode === 17) {
                return;
            }

            var arrowKeyCodes = [37, 38, 39, 40];
            if (ev.shiftKey && arrowKeyCodes.indexOf(ev.keyCode) !== -1) {
                return;
            }

            var elements = ['input', 'select', 'textarea', 'button', 'datalist', 'keygen'];
            var doNotRefocus = elements.indexOf(ev.target.tagName.toLowerCase()) > -1 || ev.target.getAttribute('contenteditable');

            if (doNotRefocus) {
                return;
            }

            _this.$refs.input.focus();
        });

        this.listen(this.$state, 'input.insertnick', function (nick) {
            if (!_this.$refs.input) {
                return;
            }

            var val = nick;
            if (_this.current_input_value === '') {
                val += ': ';
            } else {
                val += ' ';
            }

            _this.$refs.input.insertText(val);
        });

        this.listen(this.$state, 'input.tool', function (toolComponent) {
            _this.toggleInputTool(toolComponent);
        });
    },
    mounted: function mounted() {
        this.inputRestore();
    },

    methods: {
        inputUpdate: function inputUpdate(val) {
            this.current_input_value = val;

            if (_state2.default.setting('buffers.shared_input')) {
                _state2.default.ui.current_input = val;
            } else {
                this.buffer.current_input = val;
            }

            this.maybeHidePlugins();
        },
        inputRestore: function inputRestore() {
            var currentInput = _state2.default.setting('buffers.shared_input') ? _state2.default.ui.current_input : this.buffer.current_input;

            this.$refs.input.reset(currentInput);
            this.$refs.input.selectionToEnd();
        },
        toggleSelfUser: function toggleSelfUser() {
            if (this.networkState === 'connected') {
                this.selfuser_open = !this.selfuser_open;
            }
        },
        maybeHidePlugins: function maybeHidePlugins() {
            if (this.$state.ui.app_width < 500) {
                this.showPlugins = false;
            }
        },
        onToolClickTextStyle: function onToolClickTextStyle() {
            this.toggleInputTool(_TextStyle2.default);
        },
        onToolClickEmoji: function onToolClickEmoji() {
            this.toggleInputTool(_Emoji2.default);
        },
        closeInputTool: function closeInputTool() {
            this.active_tool = null;
        },
        toggleInputTool: function toggleInputTool(tool) {
            if (!tool || this.active_tool === tool) {
                this.active_tool = null;
            } else {
                this.active_tool_props = {
                    buffer: this.buffer,
                    ircinput: this.$refs.input
                };
                this.active_tool = tool;
            }
        },
        toggleBold: function toggleBold() {
            this.$refs.input.toggleBold();
        },
        toggleItalic: function toggleItalic() {
            this.$refs.input.toggleItalic();
        },
        toggleUnderline: function toggleUnderline() {
            this.$refs.input.toggleUnderline();
        },
        onAutocompleteCancel: function onAutocompleteCancel() {
            this.autocomplete_open = false;
        },
        onAutocompleteTemp: function onAutocompleteTemp(selectedValue, selectedItem) {
            if (!this.autocomplete_filtering) {
                this.$refs.input.setCurrentWord(selectedValue);
            }
        },
        onAutocompleteSelected: function onAutocompleteSelected(selectedValue, selectedItem) {
            var word = selectedValue;
            this.$refs.input.setCurrentWord(word);
            this.autocomplete_open = false;
        },
        inputKeyDown: function inputKeyDown(event) {
            var _this2 = this;

            var meta = false;

            if (navigator.appVersion.indexOf('Mac') !== -1) {
                meta = event.metaKey;
            } else {
                meta = event.ctrlKey;
            }

            if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
                return;
            }

            if (this.autocomplete_open && !this.autocomplete_filtering) {
                this.$refs.autocomplete.selectCurrentItem();
            }

            if (event.keyCode === 13) {
                event.preventDefault();
                this.submitForm();
            } else if (event.keyCode === 32) {
                if (_state2.default.setting('buffers.show_emoticons')) {
                    var currentWord = this.$refs.input.getCurrentWord();
                    var emojiList = _state2.default.setting('emojis');
                    if (emojiList.hasOwnProperty(currentWord.word)) {
                        var emoji = emojiList[currentWord.word];
                        var url = _state2.default.setting('emojiLocation') + emoji + '.png';
                        this.$refs.input.setCurrentWord('');
                        this.$refs.input.addImg(currentWord.word + ' ', url);
                    }
                }
            } else if (event.keyCode === 38) {
                event.preventDefault();
                this.historyBack();
                this.$nextTick(function () {
                    _this2.$refs.input.selectionToEnd();
                });
            } else if (event.keyCode === 40) {
                event.preventDefault();
                this.historyForward();
                this.$nextTick(function () {
                    _this2.$refs.input.selectionToEnd();
                });
            } else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
                var _currentWord = this.$refs.input.getCurrentWord();
                var currentToken = _currentWord.word.substr(0, _currentWord.position);

                var items = this.buildAutoCompleteItems({
                    users: true,
                    buffers: true
                });
                this.openAutoComplete(items);
                this.autocomplete_filter = currentToken;

                this.autocomplete_filtering = false;
                event.preventDefault();
            } else if (meta && event.keyCode === 75) {
                this.toggleInputTool(_TextStyle2.default);
                event.preventDefault();
            } else if (meta && event.keyCode === 66) {
                this.toggleBold();
                event.preventDefault();
            } else if (meta && event.keyCode === 73) {
                this.toggleItalic();
                event.preventDefault();
            } else if (meta && event.keyCode === 85) {
                this.toggleUnderline();
                event.preventDefault();
            }
        },
        inputKeyUp: function inputKeyUp(event) {
            var inputVal = this.$refs.input.getRawText();
            var currentWord = this.$refs.input.getCurrentWord();
            var currentToken = currentWord.word.substr(0, currentWord.position);

            if (event.keyCode === 27 && this.autocomplete_open) {
                this.autocomplete_open = false;
            } else if (this.autocomplete_open && currentToken === '') {
                this.autocomplete_open = false;
            } else if (this.autocomplete_open) {
                if (currentToken[0] === '@') {
                    currentToken = currentToken.substr(1);
                }
            } else if (currentToken === '@') {
                this.openAutoComplete(this.buildAutoCompleteItems({ users: true }));
                this.autocomplete_filtering = true;
            } else if (inputVal === '/') {
                this.openAutoComplete(this.buildAutoCompleteItems({ commands: true }));
                this.autocomplete_filtering = true;
            } else if (currentToken === '#') {
                this.openAutoComplete(this.buildAutoCompleteItems({ buffers: true }));
                this.autocomplete_filtering = true;
            } else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
                event.preventDefault();
            } else if (!event.key.match(/^(Shift|Control|Alt|Enter)/)) {
                if (inputVal.trim()) {
                    this.startTyping();
                } else {
                    this.stopTyping(true);
                }
            }

            if (this.autocomplete_open && this.autocomplete_filtering) {
                this.autocomplete_filter = currentToken;
            }
        },
        submitForm: function submitForm() {
            var rawInput = this.$refs.input.getValue();
            if (!rawInput) {
                return;
            }

            var ircText = this.$refs.input.buildIrcText();
            _state2.default.$emit('input.raw', ircText);

            this.history.push(rawInput);
            this.history.splice(0, this.history.length - 50);
            this.history_pos = this.history.length;

            this.$refs.input.reset();

            this.stopTyping(false);
        },
        historyBack: function historyBack() {
            if (this.history_pos > 0) {
                this.history_pos--;
            }
        },
        historyForward: function historyForward() {
            if (this.history_pos < this.history.length) {
                this.history_pos++;
            }
        },
        openAutoComplete: function openAutoComplete(items) {
            if (_state2.default.setting('showAutocomplete')) {
                this.autocomplete_items = items;
                this.autocomplete_open = true;
            }
        },
        buildAutoCompleteItems: function buildAutoCompleteItems(_opts) {
            var opts = _opts || {};
            var list = [];

            if (opts.users) {
                var userList = _lodash2.default.values(this.buffer.users).map(function (user) {
                    var item = {
                        text: user.nick,
                        type: 'user'
                    };
                    return item;
                });

                if (this.buffer.isQuery()) {
                    userList.push({
                        text: this.buffer.name,
                        type: 'user'
                    });
                }

                list = list.concat(userList);
            }

            if (opts.buffers) {
                var bufferList = [];
                this.buffer.getNetwork().buffers.forEach(function (buffer) {
                    if (buffer.isChannel()) {
                        bufferList.push({
                            text: buffer.name,
                            type: 'buffer'
                        });
                    }
                });

                list = list.concat(bufferList);
            }

            if (opts.commands) {
                var commandList = [];
                _autocompleteCommands2.default.forEach(function (command) {
                    var desc = command.description.indexOf('locale_id_') === 0 ? TextFormatting.t(command.description.substr(10)) : command.description;
                    commandList.push({
                        text: '/' + command.command,
                        description: desc,
                        type: 'command',

                        alias: (command.alias || []).map(function (c) {
                            return '/' + c;
                        })
                    });
                });

                list = list.concat(commandList);
            }

            return list;
        },
        startTyping: function startTyping() {
            if (!this.buffer.getNetwork().ircClient.network.cap.isEnabled('message-tags')) {
                return;
            }
            if (!this.buffer.setting('share_typing')) {
                return;
            }
            var buffer = this.buffer;
            var network = buffer.getNetwork();
            if (!buffer || !buffer.isChannel() && !buffer.isQuery()) {
                return;
            }
            if (this.typingTimer) {
                clearTimeout(this.typingTimer);
                this.typingTimer = null;
            }
            this.typingTimer = setTimeout(this.stopTyping, 3000);

            if (Date.now() < this.lastTypingTime + 3000) {
                return;
            }

            network.ircClient.typing.start(buffer.name);

            this.lastTypingTime = Date.now();
        },
        stopTyping: function stopTyping(sendStopPause) {
            if (!this.buffer.getNetwork().ircClient.network.cap.isEnabled('message-tags')) {
                return;
            }
            if (!this.buffer.setting('share_typing')) {
                return;
            }
            var buffer = this.buffer;
            var network = buffer.getNetwork();

            if (!buffer || !buffer.isChannel() && !buffer.isQuery()) {
                return;
            }

            if (this.typingTimer) {
                clearTimeout(this.typingTimer);
                this.typingTimer = null;
                this.lastTypingTime = 0;
            }

            if (!sendStopPause) {
                return;
            }

            this.$refs.input.getRawText().trim() ? network.ircClient.typing.pause(buffer.name) : network.ircClient.typing.stop(buffer.name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ControlInput"]
window._kiwi_exports.components.ControlInput = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ControlInput.vue
// module id = ZfkH
// module chunks = 1